__webpack_require__.p = "/global-capability-center-maturity-index/";